import React from 'react';

const SuccessIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large">
      <div className="vbz-icon-beneficiaries-large-success" />
    </div>
  );
};

export default SuccessIcon;
